"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var surveyscreeners = [utils.screeners.WHO5, utils.screeners.PSS4, utils.screeners.PSYCAP, utils.screeners.ROI_HPQ_4_DAYSLIDE, utils.screeners.ROI_HPQ_3_POINTSLIDE];
var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];
var sliderOptions = ["0", "1", "2", "3", "4", "5", "6", "7"];
var ROIoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var sleepOptions = ["Worst possible sleep", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Best possible sleep"];
var questions = screenersImport.expandscreeners([utils.screeners.PSS4, {
  prompt: "How many days in the last week did you miss work due to mental or" + " physical health reasons (e.g. stress, fatigue, illness)?",
  options: sliderOptions,
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the last week did you feel so impaired by stress," + " that even though you went to work, your productivity was reduced?",
  options: sliderOptions,
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On how many days in the past week have you felt so stressed or" + " frustrated with work that you considered changing jobs?",
  options: sliderOptions,
  eval: function _eval(n) {
    return n;
  }
}, {
  prompt: "On a scale from 0 to 10, where 0 is the worst job performance " + "anyone could have at your job and 10 is the best performance anyone " + "could have, how would you rate your overall job performance on the " + "days you worked in the past 4 weeks?",
  options: ROIoptions,
  eval: function _eval(n) {
    return n;
  }
}, utils.screeners.WHO5, {
  prompt: "Please rate the quality of your sleep over the last week.",
  options: sleepOptions,
  eval: function _eval(n) {
    return 10 * n;
  }
}, {
  prompt: "How likely are you to recommend your company to a friend as a " + "great place to work?",
  options: likelihood,
  eval: function _eval(n) {
    return n * 100 / (likelihood.length - 1);
  }
}]);
var getWHO5Score = utils.screeners.WHO5.getResults;
var getPSS4Score = utils.screeners.PSS4.getResults;

var analysis = function analysis(answers) {
  if (!answers) return null;
  var results = {};
  results.humanReadable = {};

  if (questions.length > answers.length) {
    answers.splice(25, 0, "N/A");
  }

  surveyscreeners.forEach(function (battery) {
    var batteryResults = screenersImport.extractResults(questions, answers, battery);
    var batteryHumanReadable = batteryResults.humanReadable;
    delete batteryResults.humanReadable;
    results = Object.assign(results, batteryResults);
    results.humanReadable = Object.assign(results.humanReadable, batteryHumanReadable);
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(answers[i], q);
    results.humanReadable[q.prompt] = q.eval(answers[i], q);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis,
  getWHO5Score: getWHO5Score,
  getPSS4Score: getPSS4Score
};